import cx from "classnames";
const HeaderWrapper = ({
  children
}) => {
  return <header className={cx("bg-header-bg sticky top-0 z-50 px-4 shadow-md md:px-0")} data-sentry-component="HeaderWrapper" data-sentry-source-file="HeaderWrapper.jsx">
      <div className="pointer-events-auto">{children}</div>
    </header>;
};
export default HeaderWrapper;